import React from 'react';
import styles from "../../styles.module.scss";
import moment from 'moment';
import { formattedPrice } from '../../../utils';
import { getPaymentModeDispValue } from '../../../selectPaymentMode/components/constant';
import { getPaymentReferenceNo } from '../../../selectPaymentMode/collectedPaymentDetails/utils';

const PaymentDetails = ({ collectPayment, collectVoucherList, epmrReceiptDetails }) => {

    const totalCollectedAmount = [...collectPayment, ...collectVoucherList]?.reduce((acc, curr) => acc + (+curr.paidAmount), 0);

    return (
        <>
            <div className={styles['review-details-row-value']}>Payment Details</div>

            <table className="review-details-payment-details-table">

                <tr>
                    <th className="first-column">Mode</th>
                    <th>Number</th>
                    <th>Date</th>
                    <th className="last-column">Amount</th>
                </tr>

                {[...collectPayment, ...collectVoucherList]?.map((el, idx) =>

                    <tr key={idx}>
                        <td className="first-column">{getPaymentModeDispValue(el)}</td>
                        <td>{getPaymentReferenceNo(el, epmrReceiptDetails) || "-"}</td>
                        <td>{moment(el?.paymentModeDate).format("DD-MMM-YYYY")}</td>
                        <td className="last-column">{formattedPrice(el?.paidAmount)}</td>
                    </tr>
                )}

            </table>

            <div className='mt-3'>
                <span className='view-full-breakup-card-heading'>Total Amount Paid</span>
                <span className='receipt-total-paid-amount float-right'>{formattedPrice(totalCollectedAmount)}</span>
            </div>

            <hr className='my-3' />
        </>
    );
}

export default PaymentDetails;